import React, { useState, useEffect } from "react"
import ReactTooltip from "react-tooltip"
import "./style.scss"

export function HoverTab(props) {
  const [isTooltipVisible, setTooltipVisibility] = useState(false)

  useEffect(() => {
    setTooltipVisibility(true)
  }, [])

  const { percent, answer, dataTip, disable, getContent } = props
  let uid = ""
  let roundedPercent = ""
  if (percent) {
    uid += answer
    roundedPercent += Math.round(percent * 100) + "%"
  } else {
    uid += answer + "legend"
  }

  return (
    <div className="hover-tab-card">
      <div
        data-for={uid}
        data-tip={dataTip}
        className={`hover-tab-name ${answer}`}
      >
        {`${roundedPercent} ${answer}`}
      </div>
      {dataTip && isTooltipVisible && (
        <ReactTooltip
          id={uid}
          getContent={getContent}
          className={`tool-tip ${answer}-tip`}
          place="bottom"
          effect="solid"
          textColor={"#0a2c43"}
          disable={disable}
        />
      )}
    </div>
  )
}

export function HoverTabPanel(props) {
  const { title, children, center } = props

  return (
    <div className={"hover-tab-panel"}>
      {title && <h2 className="hover-tab-title">{title}</h2>}
      <ul className="vendor-hover-tabs" data-center={center}>
        {React.Children.toArray(children).map((component, index) => {
          return <li key={index}>{component}</li>
        })}
      </ul>
    </div>
  )
}
